var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav-title"},[_c('h2',{staticClass:"nav-title__text fz-20 fw-bold"},[_vm._v(_vm._s(_vm.title))]),_c('hr',{staticClass:"nav-title__hr"})])}
var staticRenderFns = []

export { render, staticRenderFns }